var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.logLine.user)?_c('router-link',{attrs:{"to":'/users/' + _vm.logLine.user.id + '/edit'}},[_vm._v("\n        "+_vm._s(_vm.logLine.user.full_name)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.logLine.user)?_c('span',[_vm._v("·")]):_vm._e(),_vm._v("\n\n    "+_vm._s(_vm._f("datetime")(_vm.logLine.created_at))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }